import { ArrowBack as MArrowBack } from '@mui/icons-material'
import React from 'react'

interface ArrowBackProps {
  className?: string
}
export const ArrowBack: React.FC<ArrowBackProps> = () => {
  return <MArrowBack />
}
